export default "__VITE_ASSET__DnZsBlAC__"